import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { PATH_GRAPHQL_HTTP } from '../../../config'

import { actions as authActions } from '../../../reducers/auth'

import Button from './Button'
import AppeLogin from 'react-apple-login'
import { Apple } from '@material-ui/icons'

const AppleLoginBase = _props => {
  return (
    <AppeLogin
      clientId='com.glfr.my'
      redirectURI={`${PATH_GRAPHQL_HTTP}/auth/apple`}
      responseMode='form_post'
      responseType='code id_token'
      scopes='name email'
      render={({ onClick }) => (
        <Button
          buttonColor='black'
          icon={<Apple />}
          onClick={onClick}
        >
          Continue with Apple
        </Button>
      )}
    />
  )
}

export default _.compose(
  connect(() => ({}), ({
    doLogin: authActions.loginRequest
  }))
)(AppleLoginBase)
